import Dropdowns from '../../../modules/dropdowns/dropdowns';

const faqMainPageDropdowns = new Dropdowns({
	dropdownSelector: '.faq__item',
	contentSelector: '.faq__content',
});

faqMainPageDropdowns.init();
